const env = import.meta.env;

const NODE_ENV = env.VITE_NODE_ENV;
export let apiEndpoint = '';

if (NODE_ENV === 'production') {
  apiEndpoint = 'https://glitchads-prod-108905211504.europe-west4.run.app';
} else if (NODE_ENV === 'staging') {
  apiEndpoint = 'https://glitchads-staging-108905211504.europe-west4.run.app';
} else {
  apiEndpoint = env.VITE_API_URL || 'http://localhost:8000';
}

export const STRIPE_CONFIG = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  pricingTableId: import.meta.env.VITE_STRIPE_PRICING_TABLE_ID,
} as const;

if (!STRIPE_CONFIG.publishableKey || !STRIPE_CONFIG.pricingTableId) {
  throw new Error('Missing required Stripe environment variables');
}
